/** feeds: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "st_ok": "Up to date",
  "st_pending": "Waiting for approval",
  "st_failing": "Failing",
  "st_never": "Not read yet",
  "kind_manual": "Manual",
  "kind_csv": "CSV",
  "kind_json": "JSON",
  "kind_rss": "RSS / Atom",
  "every_5": "every 5 minutes",
  "every_15": "every 15 minutes",
  "every_30": "every 30 minutes",
  "every_60": "every hour",
  "every_360": "every 6 hours",
  "every_1440": "every day",
  "Every_5": "Every 5 minutes",
  "Every_15": "Every 15 minutes",
  "Every_30": "Every 30 minutes",
  "Every_60": "Every hour",
  "Every_360": "Every 6 hours",
  "Every_1440": "Every day",
  "everyNMin": "Every {n} minutes",
  "onlySync": "Only when you press Sync now",
  "syncFailed": "“{name}”: {error}",
  "syncPending": "“{name}”: an update waits for approval",
  "syncUpdated": "“{name}” updated",
  "syncSame": "“{name}” is up to date",
  "deleteQ": "Delete the data feed “{name}”? Apps that show it will keep their last data until you change them.",
  "deleteShortQ": "Delete the data feed “{name}”?",
  "deletedX": "Deleted “{name}”",
  "createdFailing": "Created “{name}”, but the source couldn’t be read: {error}",
  "createdPending": "Created “{name}”. Its data waits for your approval",
  "createdRows": "Created “{name}” with {n} row | Created “{name}” with {n} rows",
  "needAttention": "{n} needs attention | {n} need attention",
  "usingCsv": "Using {name}. The first line is the column names.",
  "previewCounts": "{rows}, {cols}",
  "nRows": "{n} row | {n} rows",
  "nCols": "{n} column | {n} columns",
  "firstShown": ": the first {n} shown",
  "approvedV": "Approved: apps now get version {v}",
  "updatedV": "Updated to version {v}",
  "savedV": "Saved. Apps now get version {v}",
  "firstData": "the first data, {n} row | the first data, {n} rows",
  "nAdded": "{n} added",
  "nRemoved": "{n} removed",
  "nChanged": "{n} changed",
  "headLine": "{kind} · {rows} · version {v}",
  "checkedAgo": "· checked {ago}",
  "changedAgo": "· changed {ago}",
  "readAgo": "Read {ago}: {diff}. Apps keep showing version {v} until you approve it.",
  "hideUpdate": "Hide the update",
  "showUpdate": "Show the update",
  "lastFailed": "The last check failed: {error}. | The last {n} checks failed: {error}.",
  "keepsGood": "Apps keep the last good data (version {v}).",
  "addressOf": "{kind} address",
  "nextCheck": "· next check {time}",
  "columnN": "Column {n}",
  "removeColQ": "Remove the column “{name}” and its values?",
  "colNameN": "Column {n} name",
  "colTypeN": "Column {n} type",
  "removeColX": "Remove column {name}",
  "keyHint": "Apps use the key “{key}”; it stays the same if you rename the column",
  "rowCell": "Row {n}, {col}",
  "deleteRow": "Delete row {n}",
  "rowsOf": "{n} / {max} rows",
  "fileTooBig": "The file is larger than 2 MB",
  "colName": "Name",
  "colValue": "Value",
  "checkForm": "Check the form",
  "title": "Data Feeds",
  "intro": "Tables of data that apps show, like menus, price lists, directories and news. Type them in, or read them from a CSV, JSON or RSS address and keep them updated.",
  "newFeed": "New Data Feed",
  "search": "Search data feeds",
  "retry": "Retry",
  "colFeed": "Data feed",
  "colItems": "Items",
  "colChecked": "Checked",
  "colChanged": "Changed",
  "colStatus": "Status",
  "actions": "Actions",
  "reading": "Reading…",
  "syncNow": "Sync now",
  "open": "Open",
  "delete": "Delete",
  "loading": "Loading…",
  "noMatch": "No data feeds match.",
  "noFeeds": "No data feeds yet",
  "emptyHint": "Keep a menu, a price list or a staff directory in one place, and every app that shows it updates when it changes.",
  "drawerDesc": "Data Feeds change the data apps show, without editing the apps.",
  "namePh": "Café menu",
  "optional": "(optional)",
  "tags": "Tags",
  "whereFrom": "Where the data comes from",
  "manualTitle": "Manual",
  "manualHint": "Type your data in a table, or start from a CSV file.",
  "fromAddress": "From an address",
  "fromAddressHint": "Read a CSV, JSON or RSS link and keep it updated.",
  "startCsv": "Start from a CSV file",
  "twoColumns": "Otherwise the feed starts with two empty columns you can rename.",
  "format": "Format",
  "address": "Address",
  "itemsPath": "Items path",
  "itemsPathHint": "Where the list is, with dots. Leave blank if the JSON is the list, or has only one.",
  "keepChecking": "Keep updated, checking",
  "howOften": "How often",
  "useStraight": "Use updates straight away",
  "untickFirst": "Untick to check each update first: it waits in “Waiting for approval” until an editor approves it.",
  "preview": "Preview",
  "onlyFirst1000": ". Only the first 1,000 are used.",
  "cancel": "Cancel",
  "creating": "Creating…",
  "create": "Create",
  "leaveQ": "You have unsaved changes. Leave without saving?",
  "rejectQ": "Reject this update? Apps keep the current data. The same data won’t be offered again; a later change will.",
  "rejected": "Update rejected",
  "notRead": "The source could not be read",
  "waits": "An update waits for approval",
  "upToDate": "Already up to date",
  "saved": "Saved",
  "columnsChanged": "the columns changed",
  "noRowChanges": "no row changes",
  "back": "Back to Data Feeds",
  "unsaved": "Unsaved",
  "saving": "Saving…",
  "save": "Save",
  "reject": "Reject",
  "approving": "Approving…",
  "approve": "Approve",
  "waitingUpdate": "The waiting update",
  "data": "Data",
  "whatAppsShow": "What apps show",
  "approvedData": "Approved data",
  "nothingApproved": "Nothing approved yet: approve the update above.",
  "noData": "No data yet. Press Sync now to read the source.",
  "settings": "Settings",
  "addrChange": "Changing the address reads it again when you save.",
  "keepUpdated": "Keep updated",
  "untickApprove": "Untick to approve each update before apps get it.",
  "manualSave": "Saving a changed table makes it the new version apps get.",
  "deleteFeed": "Delete this data feed",
  "tText": "Text",
  "tNumber": "Number",
  "tImage": "Image URL",
  "tLink": "Link",
  "tDate": "Date",
  "row": "Row",
  "addColumn": "+ Column",
  "addRow": "+ Row",
  "pasteTip": "Tip: copy cells in Excel or Google Sheets and paste them into a cell to fill many at once.",
  "noRows": "No rows yet."
};
const ar: typeof en = {
  "st_ok": "محدّث",
  "st_pending": "بانتظار الموافقة",
  "st_failing": "يفشل",
  "st_never": "لم يُقرأ بعد",
  "kind_manual": "يدوي",
  "kind_csv": "CSV",
  "kind_json": "JSON",
  "kind_rss": "RSS / Atom",
  "every_5": "كل ٥ دقائق",
  "every_15": "كل ١٥ دقيقة",
  "every_30": "كل ٣٠ دقيقة",
  "every_60": "كل ساعة",
  "every_360": "كل ٦ ساعات",
  "every_1440": "كل يوم",
  "Every_5": "كل ٥ دقائق",
  "Every_15": "كل ١٥ دقيقة",
  "Every_30": "كل ٣٠ دقيقة",
  "Every_60": "كل ساعة",
  "Every_360": "كل ٦ ساعات",
  "Every_1440": "كل يوم",
  "everyNMin": "كل {n} دقيقة",
  "onlySync": "فقط عند الضغط على «مزامنة الآن»",
  "syncFailed": "«{name}»: {error}",
  "syncPending": "«{name}»: تحديث بانتظار الموافقة",
  "syncUpdated": "تم تحديث «{name}»",
  "syncSame": "«{name}» محدّث",
  "deleteQ": "حذف مصدر البيانات «{name}»؟ ستحتفظ التطبيقات التي تعرضه بآخر بياناتها حتى تغيّرها.",
  "deleteShortQ": "حذف مصدر البيانات «{name}»؟",
  "deletedX": "تم حذف «{name}»",
  "createdFailing": "تم إنشاء «{name}»، لكن تعذّرت قراءة المصدر: {error}",
  "createdPending": "تم إنشاء «{name}». بياناته بانتظار موافقتك",
  "createdRows": "تم إنشاء «{name}» بلا صفوف | تم إنشاء «{name}» بصف واحد | تم إنشاء «{name}» بصفين | تم إنشاء «{name}» بـ {n} صفوف | تم إنشاء «{name}» بـ {n} صفًا | تم إنشاء «{name}» بـ {n} صف",
  "needAttention": "لا شيء يحتاج انتباهًا | واحد يحتاج انتباهًا | اثنان يحتاجان انتباهًا | {n} تحتاج انتباهًا | {n} تحتاج انتباهًا | {n} تحتاج انتباهًا",
  "usingCsv": "يُستخدم {name}. السطر الأول أسماء الأعمدة.",
  "previewCounts": "{rows}، {cols}",
  "nRows": "لا صفوف | صف واحد | صفان | {n} صفوف | {n} صفًا | {n} صف",
  "nCols": "لا أعمدة | عمود واحد | عمودان | {n} أعمدة | {n} عمودًا | {n} عمود",
  "firstShown": "؛ يظهر أول {n}",
  "approvedV": "تمت الموافقة: تحصل التطبيقات الآن على النسخة {v}",
  "updatedV": "تم التحديث إلى النسخة {v}",
  "savedV": "تم الحفظ. تحصل التطبيقات الآن على النسخة {v}",
  "firstData": "البيانات الأولى، بلا صفوف | البيانات الأولى، صف واحد | البيانات الأولى، صفان | البيانات الأولى، {n} صفوف | البيانات الأولى، {n} صفًا | البيانات الأولى، {n} صف",
  "nAdded": "{n} مضاف",
  "nRemoved": "{n} محذوف",
  "nChanged": "{n} معدّل",
  "headLine": "{kind} · {rows} · النسخة {v}",
  "checkedAgo": "· فُحص {ago}",
  "changedAgo": "· تغيّر {ago}",
  "readAgo": "قُرئ {ago}: {diff}. تواصل التطبيقات عرض النسخة {v} حتى توافق عليه.",
  "hideUpdate": "إخفاء التحديث",
  "showUpdate": "إظهار التحديث",
  "lastFailed": "فشل آخر فحص: {error}. | فشل آخر فحص: {error}. | فشل آخر فحصين: {error}. | فشلت آخر {n} فحوص: {error}. | فشل آخر {n} فحصًا: {error}. | فشل آخر {n} فحص: {error}.",
  "keepsGood": "تحتفظ التطبيقات بآخر بيانات سليمة (النسخة {v}).",
  "addressOf": "عنوان {kind}",
  "nextCheck": "· الفحص التالي {time}",
  "columnN": "العمود {n}",
  "removeColQ": "إزالة العمود «{name}» وقيمه؟",
  "colNameN": "اسم العمود {n}",
  "colTypeN": "نوع العمود {n}",
  "removeColX": "إزالة العمود {name}",
  "keyHint": "تستخدم التطبيقات المفتاح «{key}»؛ ويبقى كما هو إذا أعدت تسمية العمود",
  "rowCell": "الصف {n}، {col}",
  "deleteRow": "حذف الصف {n}",
  "rowsOf": "{n} / {max} صف",
  "fileTooBig": "الملف أكبر من ٢ ميغابايت",
  "colName": "الاسم",
  "colValue": "القيمة",
  "checkForm": "تحقق من النموذج",
  "title": "مصادر البيانات",
  "intro": "جداول بيانات تعرضها التطبيقات، مثل القوائم وقوائم الأسعار والأدلة والأخبار. اكتبها بنفسك، أو اقرأها من عنوان CSV أو JSON أو RSS وأبقِها محدّثة.",
  "newFeed": "مصدر بيانات جديد",
  "search": "البحث في مصادر البيانات",
  "retry": "إعادة المحاولة",
  "colFeed": "مصدر البيانات",
  "colItems": "العناصر",
  "colChecked": "آخر فحص",
  "colChanged": "آخر تغيير",
  "colStatus": "الحالة",
  "actions": "الإجراءات",
  "reading": "جارٍ القراءة…",
  "syncNow": "مزامنة الآن",
  "open": "فتح",
  "delete": "حذف",
  "loading": "جارٍ التحميل…",
  "noMatch": "لا توجد مصادر بيانات مطابقة.",
  "noFeeds": "لا توجد مصادر بيانات بعد",
  "emptyHint": "احفظ قائمة طعام أو قائمة أسعار أو دليل موظفين في مكان واحد، فيتحدث كل تطبيق يعرضها عند تغيّرها.",
  "drawerDesc": "تغيّر مصادر البيانات ما تعرضه التطبيقات دون تعديلها.",
  "namePh": "قائمة المقهى",
  "optional": "(اختياري)",
  "tags": "الوسوم",
  "whereFrom": "مصدر البيانات",
  "manualTitle": "يدوي",
  "manualHint": "اكتب بياناتك في جدول، أو ابدأ من ملف CSV.",
  "fromAddress": "من عنوان",
  "fromAddressHint": "اقرأ رابط CSV أو JSON أو RSS وأبقِه محدّثًا.",
  "startCsv": "البدء من ملف CSV",
  "twoColumns": "وإلا يبدأ المصدر بعمودين فارغين يمكنك إعادة تسميتهما.",
  "format": "الصيغة",
  "address": "العنوان",
  "itemsPath": "مسار العناصر",
  "itemsPathHint": "مكان القائمة، بالنقاط. اتركه فارغًا إذا كان JSON هو القائمة أو يحتوي قائمة واحدة فقط.",
  "keepChecking": "إبقاؤه محدّثًا، بالفحص",
  "howOften": "عدد المرات",
  "useStraight": "استخدام التحديثات فورًا",
  "untickFirst": "ألغِ التحديد لفحص كل تحديث أولًا: ينتظر في «بانتظار الموافقة» حتى يوافق عليه محرر.",
  "preview": "معاينة",
  "onlyFirst1000": ". تُستخدم أول ١٬٠٠٠ فقط.",
  "cancel": "إلغاء",
  "creating": "جارٍ الإنشاء…",
  "create": "إنشاء",
  "leaveQ": "لديك تغييرات غير محفوظة. هل تريد المغادرة دون حفظ؟",
  "rejectQ": "رفض هذا التحديث؟ تحتفظ التطبيقات بالبيانات الحالية. لن تُعرض البيانات نفسها مجددًا؛ أما التغيير اللاحق فسيُعرض.",
  "rejected": "تم رفض التحديث",
  "notRead": "تعذّرت قراءة المصدر",
  "waits": "تحديث بانتظار الموافقة",
  "upToDate": "محدّث بالفعل",
  "saved": "تم الحفظ",
  "columnsChanged": "تغيّرت الأعمدة",
  "noRowChanges": "لا تغييرات في الصفوف",
  "back": "العودة إلى مصادر البيانات",
  "unsaved": "غير محفوظ",
  "saving": "جارٍ الحفظ…",
  "save": "حفظ",
  "reject": "رفض",
  "approving": "جارٍ الموافقة…",
  "approve": "موافقة",
  "waitingUpdate": "التحديث المنتظر",
  "data": "البيانات",
  "whatAppsShow": "ما تعرضه التطبيقات",
  "approvedData": "البيانات المعتمدة",
  "nothingApproved": "لم يُعتمد شيء بعد: وافق على التحديث أعلاه.",
  "noData": "لا توجد بيانات بعد. اضغط «مزامنة الآن» لقراءة المصدر.",
  "settings": "الإعدادات",
  "addrChange": "تغيير العنوان يعيد قراءته عند الحفظ.",
  "keepUpdated": "إبقاؤه محدّثًا",
  "untickApprove": "ألغِ التحديد للموافقة على كل تحديث قبل أن تحصل عليه التطبيقات.",
  "manualSave": "حفظ جدول معدّل يجعله النسخة الجديدة التي تحصل عليها التطبيقات.",
  "deleteFeed": "حذف مصدر البيانات هذا",
  "tText": "نص",
  "tNumber": "رقم",
  "tImage": "رابط صورة",
  "tLink": "رابط",
  "tDate": "تاريخ",
  "row": "الصف",
  "addColumn": "+ عمود",
  "addRow": "+ صف",
  "pasteTip": "نصيحة: انسخ خلايا من Excel أو Google Sheets والصقها في خلية لملء عدة خلايا دفعة واحدة.",
  "noRows": "لا توجد صفوف بعد."
};
export default { en, ar };
